import React from 'react';
import { Contact } from 'components/contact/Contact';

export const Component = () => {
  return (
    <Contact
      title="Media Contact"
      name="Name Nameson"
      text={<p>Vice President Organizational Development Global Communications &amp; Branding</p>}
      phone="(354) 522-2900"
      email="name@organization.com"
      linkedin={{ href: 'https://kodo.is' }}
      isSlice
      linkTagline="Media Gallery"
      linkTitle="Download center, logos and photos"
      link={{ href: 'https://kodo.is' }}
    />
  );
};
